<div class="card card-stretch h-100 rounded-0 context-menu">
    <div class="card-header p-3 d-flex justify-content-between border-bottom-0">
        <h5 class="card-title mb-0 font-weight-bolder">
            <img src="../../../../assets/common/images/Activities/MydashboardProject.svg" class="h-20px w-20px mr-2" />   {{'MyProjects' |localize}}
        </h5>
        <div *ngIf="Loaded && !Empty"  class="ml-auto cursor-pointer card-toolbar">
            <div class="font-weight-bolder text-primary cursor-pointer" (click)="viewall()">
                {{ 'ViewAll' | localize}}
            </div>
        </div>
    </div>

    <div class="card-body p-0 pb-3">
        <!--Empty State UI Code-->

        <div *ngIf="Loaded && Empty">
            <div class="d-flex justify-content-center">
                <div class="d-flex flex-column mt-20">
                    <img src="../../../../assets/common/images/new-dashboard/project-empty-ui.svg" class="h-200px w-275px  ml-8" />
                    <h6 class="text-muted mt-4 ml-30">{{'NoDataFounds'|localize}}</h6>
                </div>
            </div>
        </div>


        <!--Shimmer Code-->
        <div *ngIf="!Loaded && Empty">
            <div class="row px-3 mt-4" *ngFor="let x of [1, 2, 3, 4]">
                <div class="col-md-2">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                </div>

                <div class="col-md-2">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                </div>

                <div class="col-md-2">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                </div>

                <div class="col-md-2">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                </div>
                <div class="col-md-2">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                </div>

                <div class="col-md-2">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                </div>

            </div>
        </div>

        <!--Project Section Code-->

        <div *ngIf="Loaded && !Empty">
            <div class="row px-4" id="dashboard-project">
                <div id="dashBoard-Project-data-table overflow-auto">
                    <p-table [value]="this.projectDetails" [rows]="5" [paginator]="false">
                        <ng-template pTemplate="header">
                            <tr [ngClass]="'textcolor'">
                                <th>{{'ProjectName' |localize}}</th>
                                <th>{{'ProgressBar'|localize}}</th>
                                <th >{{'StartDate'|localize}}</th>
                                <th>{{'EndDate'|localize}}</th>
                                <th>{{'Status'|localize}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-ProjectDetailsDto>
                            <tr [ngClass]="'textcolor bg-hover-gray-100'" id="pointerClassOrg">
                                <td>
                                    <div class="d-flex ">
                                        <div class="d-flex align-items-center">

                                            <div>
                                                <img alt="Pic" *ngIf="ProjectDetailsDto.projectImage" [src]="ProjectDetailsDto.projectImage" class="h-30px  w-30px border border-light rounded" id="profimgsize" />
                                                <img alt="Pic" *ngIf="!ProjectDetailsDto.projectImage" src="assets/common/images/projects/default image for project -1.png" class="h-30px  w-30px border border-light rounded" id="profimgsize" />
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column ml-3 justify-content-center" pTooltip="{{ProjectDetailsDto.projectName}}" [tooltipDisabled]="DisableTooltip(ProjectDetailsDto.projectName, 15)" tooltipPosition="bottom">
                                            {{ProjectDetailsDto.projectName| slice:0:15}}{{ProjectDetailsDto.projectName.length > 15 ? '...' : '' }}
                                            <div class="font10" pTooltip="{{ProjectDetailsDto.clientName}}" [tooltipDisabled]="DisableTooltip(ProjectDetailsDto.clientName, 16)" tooltipPosition="bottom">{{ProjectDetailsDto.clientName| slice:0:15}}{{ProjectDetailsDto.clientName > 15 ? '...' : '' }}</div>

                                        </div>


                                    </div>
                                </td>
                                <td>
                                    <div class="">
                                        <div class="progress mr-10" style="height: 7px;">
                                            <div class="progress-bar" role="progressbar" [ngStyle]="{'width': HoursLoggedBarCalculation(ProjectDetailsDto.projectStartDate, ProjectDetailsDto.projectEndDate) + '%'}" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        <label>{{HoursLoggedBarCalculation(ProjectDetailsDto.projectStartDate, ProjectDetailsDto.projectEndDate)}}%</label>
                                    </div>
                                </td>
                                <!-- <td *ngIf="!isEmployee">
                                 <div class="d-flex">
                                     <div class="d-flex align-items-center">
                                         <div class="d-flex justify-content-center align-items-end  rounded w-100">
                                             <img *ngIf="ProjectDetailsDto.clientImage" [src]="ProjectDetailsDto.clientImage" class="m-2 w-35px h-35px">
                                             <img *ngIf="!ProjectDetailsDto.clientImage" src="assets/common/images/default-profile-picture1.svg" class="m-2 w-35px h-35px" />

                                         </div>
                                     </div>
                                     <div class="d-flex flex-column  justify-content-center">

                                         <div class="font10" pTooltip="{{ProjectDetailsDto.clientName}}" [tooltipDisabled]="DisableTooltip(ProjectDetailsDto.clientName, 16)" tooltipPosition="bottom">{{ProjectDetailsDto.clientName| slice:0:15}}{{ProjectDetailsDto.clientName > 15 ? '..' : '' }}</div>
                                         <div class="font10">{{ProjectDetailsDto.clientEmail?ProjectDetailsDto.clientEmail : '-'}}</div>
                                         <div class="font10">{{ProjectDetailsDto.clientMobile?ProjectDetailsDto.clientMobile : '-'}}</div>
                                     </div>
                                 </div>

                             </td>-->
                                <td>
                                    {{ProjectDetailsDto.projectStartDate | dateFormat}}
                                </td>
                                <td>
                                    <div>

                                        {{ProjectDetailsDto.projectEndDate | dateFormat}}
                                    </div>

                                </td>
                                <td>

                                    <!--
                                   old ngClass
                                    [ngClass]="{'border-warning': ProjectDetailsDto.projectStatus == 2,'border-success': ProjectDetailsDto.projectStatus == 3,'border-primary': ProjectDetailsDto.projectStatus == 1,'w-80px':ProjectDetailsDto.projectStatus == 3,'w-70px':ProjectDetailsDto.projectStatus == 2,'w-50px':ProjectDetailsDto.projectStatus == 4}"
                                -->
                                    <span class="label label-outline-secondary rounded-pill h-28px label-inline border  bg-white" [ngClass]="{'status-width':ProjectDetailsDto.projectStatus == 3}">
                                        <span class="span-allign-center text-center mx-auto">
                                            <span class="label label-dot" [ngClass]="{'label-primary':ProjectDetailsDto.projectStatus == 1,'label-info':ProjectDetailsDto.projectStatus == 2,'label-success':ProjectDetailsDto.projectStatus == 3,'label-danger':ProjectDetailsDto.projectStatus == 4}"></span>
                                            <span *ngIf="ProjectDetailsDto.projectStatus == 1" class="ml-2">{{'New'|localize}}</span>
                                            <span *ngIf="ProjectDetailsDto.projectStatus == 2" class="ml-2">{{'Active'| localize}}</span>
                                            <span *ngIf="ProjectDetailsDto.projectStatus == 3" class="ml-2">{{'Complete'|localize}}</span>
                                            <span *ngIf="ProjectDetailsDto.projectStatus == 4" class="ml-2">{{'Closed'|localize}}</span>
                                        </span>

                                    </span>

                                </td>
                            </tr>
                        </ng-template>
                    </p-table>


                    <div class="primeng-paging-container ml-auto">
                        <p-paginator [rows]="4"
                                     #paginator
                                     [alwaysShow]="false"
                                     [showJumpToPageDropdown]="false">
                        </p-paginator>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
